import EChartsController from "../echarts_controller"
import * as Turbo from "@hotwired/turbo"

export default class extends EChartsController {
  static values = {
    data: { type: Array, default: [] },
    barColor: { type: String, default: "#3F83F8" },
    visitUrl: { type: Boolean, default: true },
  }

  chartTargetConnected(target) {
    super.chartTargetConnected(target)
    this.renderChart(
      this.chart,
      this.dataValue,
      this.barColorValue,
      this.visitUrlValue,
    )
  }

  renderChart(chart, data, barColor, visitUrl) {
    const option = {
      tooltip: {
        trigger: "item",
        confine: true,
      },
      grid: {
        left: "1%",
        top: "2%",
        right: "1%",
        bottom: "2%",
        containLabel: true,
      },
      xAxis: {
        type: "value",
        minInterval: 1,
        axisLine: { show: false },
        axisTick: { show: false },
        splitLine: { show: false },
        axisLabel: {
          color: "#B6C7D8",
          fontSize: 14,
          fontWeight: "500",
        },
      },
      yAxis: {
        type: "category",
        inverse: true,
        data: data.map((item) => item.ioc),
        axisLine: { show: false },
        axisTick: { show: false },
        axisLabel: {
          color: "#B6C7D8",
          fontWeight: "500",
          fontSize: 14,
        },
      },
      series: [
        {
          type: "bar",
          data: data.map((item) => item.count),
          barWidth: 20,
          itemStyle: {
            color: this.barColorValue,
            borderRadius: [0, 10, 10, 0],
          },
          label: {
            show: false,
          },
        },
      ],
    }

    chart.setOption(option)

    if (visitUrl) {
      const handleBarSelect = (params) => {
        const item = data.find((item) => item.ioc === params.name)
        Turbo.visit(item.url)
      }
      chart.on("click", handleBarSelect)
    }
  }
}
